import axios from 'axios';
import { getApiUrl } from '../../../config';

export function requestSearch(query, type = 'all', from = 0, limit) {
    return axios.request({
        method: 'get',
        url: `${getApiUrl()}/search`,
        params: { q: query, type, from, ...(limit ? { limit } : {}) },
        withCredentials: true,
        crossorigin: true,
    });
}
